import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoaddingPage = () =>{
    const antIcon = <LoadingOutlined style={{ fontSize: 32 }} spin />;
    return (
        <div className='erp-loadding'>
            <Spin indicator={antIcon} />
        </div>
    );
};

export default LoaddingPage;